var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUnlock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.902 29.2969H19.0979C17.2198 29.2969 15.6973 30.8194 15.6973 32.6975V44.5996C15.6973 46.4777 17.2198 48.0002 19.0979 48.0002H42.902C44.7801 48.0002 46.3026 46.4777 46.3026 44.5996V32.6975C46.3026 30.8194 44.7801 29.2969 42.902 29.2969Z",
    stroke: "white",
    strokeWidth: 3.4006,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4981 29.2956V22.4944C22.4959 20.3861 23.2773 18.3523 24.6904 16.7877C26.1035 15.223 28.0475 14.2393 30.1452 14.0274C32.2428 13.8156 34.3443 14.3906 36.0417 15.6411C37.7392 16.8915 38.9115 18.728 39.331 20.7941",
    stroke: "white",
    strokeWidth: 3.4006,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnlock);
export default __webpack_public_path__ + "static/media/unlock.e1421a23c3cde00ee8c5da618c97dd44.svg";
export { ForwardRef as ReactComponent };